module.exports = __webpack_public_path__ + "static/vahe-f075e034dc2c9d3c4ea23e79a8d5095e.png";